import { useCurrentSite } from '@ui/hooks/useCurrentSite';
import { useMemo } from 'react';

export const useCurrentSiteConfig = () => {
  const { siteConfig } = useCurrentSite();

  const configs = useMemo(
    () => ({
      siteConfig,
      quotingConfig: siteConfig.quotingConfig,
      pricingConfig: siteConfig.quotingConfig.pricingConfig,
      costingConfig: siteConfig.quotingConfig.costingConfig,
    }),
    [siteConfig],
  );

  return configs;
};
